const Troubleshooting = () => {
    return (
        <div className="container-custom py-12">
            <h1 className="text-3xl font-bold mb-4">Troubleshooting Guide</h1>
            <p className="text-gray-700 mb-6">
                Having issues? Here are simple steps to fix common problems with your cable or internet service.
            </p>
            <ul className="list-disc list-inside space-y-2">
                <li>🔌 No Signal: Check cable connection behind your TV.</li>
                <li>🔄 No Channel List: Reboot your set-top box using remote power button.</li>
                <li>📶 Weak Signal: Ensure the cable line is not broken or bent.</li>
                <li>📞 Still not working? Call our local technician at +91-9842680525.</li>
            </ul>
        </div>
    )
}

export default Troubleshooting